<template>
  <v-card :loading="busy">
    <v-card-title>
      {{ device.display_name }}
      <v-spacer></v-spacer>
      <v-btn
          v-if="switchable"
          icon
          large
          :color="device.on ? 'orange' : 'grey'"
          :disabled="busy"
          @click="toggle"
      >
        <v-icon size="36">{{ icon }}</v-icon>
      </v-btn>
      <v-icon v-else size="36" class="ma-1">{{ icon }}</v-icon>
    </v-card-title>

    <v-card-subtitle align="left">
      {{ device.type }}
      <span v-if="device.reachable === false"> · nicht erreichbar</span>
    </v-card-subtitle>

    <!-- Steckdose: Stromdaten -->
    <v-card-text v-if="device.category === 'plug'" align="left">
      <v-chip small class="mr-2" :color="device.on ? 'orange' : ''">
        <v-icon small left>mdi-flash</v-icon>
        {{ (device.apower != null ? device.apower.toFixed(1) : '–') }} W
      </v-chip>
      <v-chip small>
        <v-icon small left>mdi-counter</v-icon>
        {{ (device.total_energy != null ? (device.total_energy / 1000).toFixed(2) : '–') }} kWh gesamt
      </v-chip>
    </v-card-text>

    <!-- Lampe: Farbe + Helligkeit -->
    <v-card-text v-if="device.category === 'lamp'" align="left">
      <template v-if="device.supports_color">
        <v-avatar
            v-for="preset in presets"
            :key="preset.label"
            :color="hex(preset.rgb)"
            size="26"
            class="mr-2 preset"
            :title="preset.label"
            @click="setColor(preset.rgb)"
        ></v-avatar>
        <v-btn icon small :title="'Eigene Farbe'" @click="pickerOpen = !pickerOpen">
          <v-icon>mdi-palette</v-icon>
        </v-btn>
        <v-color-picker
            v-if="pickerOpen"
            class="mt-2"
            mode="rgba"
            hide-mode-switch
            @input="pickerColor = $event"
        ></v-color-picker>
        <v-btn
            v-if="pickerOpen"
            small
            class="mt-2"
            :disabled="busy || !pickerColor"
            @click="applyPicker"
        >
          Übernehmen
        </v-btn>
      </template>
      <v-slider
          v-model="brightness"
          class="mt-4"
          label="Helligkeit"
          hide-details
          :min="0"
          :max="254"
          :disabled="busy"
          @change="setBrightness"
      ></v-slider>
    </v-card-text>
  </v-card>
</template>

<script>
import { smarthausApi, COLOR_PRESETS, CATEGORY_ICONS, rgbToHex } from '../../../services/smarthaus'

export default {
  name: 'DeviceCard',
  props: {
    device: { type: Object, required: true },
  },
  data: () => ({
    busy: false,
    pickerOpen: false,
    pickerColor: null,
    brightness: 0,
    presets: COLOR_PRESETS,
  }),
  computed: {
    icon() {
      return CATEGORY_ICONS[this.device.category] || CATEGORY_ICONS.other
    },
    switchable() {
      return this.device.category === 'lamp' || this.device.category === 'plug'
    },
  },
  watch: {
    'device.brightness': {
      immediate: true,
      handler(v) { if (v != null) this.brightness = v },
    },
  },
  methods: {
    hex(rgb) { return rgbToHex(rgb[0], rgb[1], rgb[2]) },
    async run(promise) {
      this.busy = true
      try {
        const data = await promise
        if (data && data.device) this.$emit('updated', data.device)
      } catch (e) {
        console.error('[DeviceCard]', e)
      } finally {
        this.busy = false
      }
    },
    toggle() { return this.run(smarthausApi.deviceOn(this.device.id, !this.device.on)) },
    setColor(rgb) { return this.run(smarthausApi.deviceColor(this.device.id, rgb[0], rgb[1], rgb[2])) },
    setBrightness(v) { return this.run(smarthausApi.deviceBrightness(this.device.id, Math.round(v))) },
    applyPicker() {
      const c = this.pickerColor
      if (c && c.rgba) this.setColor([Math.round(c.rgba.r), Math.round(c.rgba.g), Math.round(c.rgba.b)])
    },
  },
}
</script>

<style scoped>
.preset {
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.3) !important;
}
</style>
